<template>
    <section class="category-sec">

        <div class="container">
            <div class="category-sec__element_row">

                <div class="category-sec__element" v-for="item in content">
                    <a :href="item.slug" class="category-sec__element-img">
                        <picture class="category-sec__element-img-element">
                            <source :srcset="item.image.webp" type="image/webp">

                            <img :alt="item.name" :src="item.image.jpeg" class="category-sec__element-img-element">
                        </picture>
                    </a>
                    <div class="category-sec__element-info">
                        <p class="category-sec__element-subtitle">
                            {{ item.name }}
                        </p>
                        <h3 class="category-sec__element-title">
                            <a :href="item.slug" class="category-sec__element-link"> {{ item.name }} </a>
                        </h3>
                    </div>
                </div>





            </div>
        </div>

    </section>
</template>

<script>
export default {
    props: {
        content: {
            type: Object,
        },


    },
    name: "category-sec"
}
</script>

<style scoped>

</style>
